export default __webpack_public_path__ + "static/media/middle-tree.1e01c79a.jpeg";